class LimeHero3D {
  constructor(containerId = 'lime-hero-sculpture', isCta = false) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;
    
    this.image = this.container.querySelector('.lime-hero-sculpture-img');
    if (!this.image) return;
    
    this.isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    this.mouseX = 0;
    this.mouseY = 0;
    this.targetX = 0;
    this.targetY = 0;
    this.animating = false;

    if (!this.isReducedMotion) {
      this.initEvents();
    }
  }

  initEvents() {
    // We attach the event to the whole composition or window so it tracks nicely
    const composition = this.container.closest('.lime-hero-composition');
    const trackArea = composition || this.container;
    
    trackArea.addEventListener('mousemove', (e) => {
      const rect = trackArea.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      this.targetX = (x / rect.width) * 2 - 1;
      this.targetY = -(y / rect.height) * 2 + 1;
      
      if (!this.animating) {
        this.animating = true;
        requestAnimationFrame(this.animate.bind(this));
      }
    });

    trackArea.addEventListener('mouseleave', () => {
      this.targetX = 0;
      this.targetY = 0;
      if (!this.animating) {
        this.animating = true;
        requestAnimationFrame(this.animate.bind(this));
      }
    });
  }

  animate() {
    this.mouseX += (this.targetX - this.mouseX) * 0.1;
    this.mouseY += (this.targetY - this.mouseY) * 0.1;
    
    // Translation (max 4px for sculpture per user request)
    const transX = this.mouseX * 4;
    const transY = -this.mouseY * 4;
    
    if (this.image) {
      this.image.style.transform = `translate3d(${transX}px, ${transY}px, 0)`;
    }
    
    if (Math.abs(this.targetX - this.mouseX) > 0.001 || Math.abs(this.targetY - this.mouseY) > 0.001) {
      requestAnimationFrame(this.animate.bind(this));
    } else {
      this.animating = false;
    }
  }
}

export default LimeHero3D;
window.LimeHero3D = LimeHero3D;
